import React from 'react';
import './Contact.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';

const Contact = () => {
  return (
    <section className="contact" id="contact">
      <div className="contact-content">
        <h2>Let's Connect</h2>
        <p className="contact-subtitle">
          Always open to discussing new projects, opportunities, or just chatting about tech.
        </p>

        <div className="contact-grid">
          <a href="mailto:atri.v.vyas@gmail.com" className="contact-card">
            <div className="card-icon-wrapper">
              <FontAwesomeIcon icon={faEnvelope} className="card-icon" />
            </div>
            <div className="card-info">
              <h3>Email</h3>
              <span>atri.v.vyas@gmail.com</span>
            </div>
            <div className="card-arrow">→</div>
          </a>

          <a href="http://www.linkedin.com/in/atrivyas/" target="_blank" rel="noopener noreferrer" className="contact-card">
            <div className="card-icon-wrapper">
              <FontAwesomeIcon icon={faLinkedin} className="card-icon" />
            </div>
            <div className="card-info">
              <h3>LinkedIn</h3>
              <span>Connect on LinkedIn</span>
            </div>
            <div className="card-arrow">→</div>
          </a>

          <a href="http://www.github.com/Atri-lab" target="_blank" rel="noopener noreferrer" className="contact-card">
            <div className="card-icon-wrapper">
              <FontAwesomeIcon icon={faGithub} className="card-icon" />
            </div>
            <div className="card-info">
              <h3>GitHub</h3>
              <span>Check out my code</span>
            </div>
            <div className="card-arrow">→</div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
